// Select from props

export const getOrderIdFromProps = (_: unknown, props: { orderId: string }) => props.orderId;
export const getOrderObjectIdFromProps = (_: unknown, props: { orderObjectId: string }) =>
  props.orderObjectId;
export const getOrderObjectIdsFromProps = (
  _: unknown,
  props: { orderObjectIds: readonly string[] },
) => props.orderObjectIds;
export const getBatchEntryIdFromProps = (_: unknown, props: { batchEntryId: number }) =>
  props.batchEntryId;
export const getBatchEntryIdsFromProps = (_: unknown, props: { batchEntryIds: number[] }) =>
  props.batchEntryIds;

export const getTransactionObjectIdFromProps = (
  _: unknown,
  props: { transactionObjectId: string },
) => props.transactionObjectId;
